import React, { useEffect, useState, useRef } from "react"
import { connect, useSelector } from "react-redux"
import { setBreadcrumbItems } from "../../store/actions"
import { Card, CardBody, Row, Col, TabContent, TabPane } from "reactstrap"
import SimpleBar from "simplebar-react/dist"
import ReactApexChart from "react-apexcharts"
import SnackbarComponent from "components/SnackBar"
import Spinners from "components/Common/Spinner"
import UserJPG from "../../assets/images/user.jpg"
import axios from "axios"
import { Link } from "react-router-dom"

const CustomerDetails = props => {
  document.title = "Instagram Post Insights"

  const [isLoading, setLoading] = useState(false)
  const [post, setPost] = useState(null)
  const [err, setErr] = useState(null)
  const [success, setSuccess] = useState(null)
  const [activeTab, setactiveTab] = useState("1")
  const [currentActiveTab, setCurrentActiveTab] = useState("Details")

  const activeOrganization = useSelector(
    state => state.organizationReducer.activeOrganization,
  )
  const mode = useSelector(state => state.Layout.layoutMode)

  const fetchPost = async () => {
    try {
      setLoading(true)
      let response
      if (props.post.media_type === "IMAGE") {
        response = await axios.get(
          `https://graph.facebook.com/v20.0/${props.post.id}/insights?metric=reach,likes,comments,saved&access_token=${activeOrganization.InstagramIntegrations[0].pageToken}`,
        )
      } else if (props.post.media_type === "VIDEO") {
        response = await axios.get(
          `https://graph.facebook.com/v20.0/${props.post.id}/insights?metric=reach,video_views,plays,likes,comments,saved&access_token=${activeOrganization.InstagramIntegrations[0].pageToken}`,
        )
      } else if (props.post.media_type === "REELS") {
        response = await axios.get(
          `https://graph.facebook.com/v20.0/${props.post.id}/insights?metric=ig_reels_video_view_total_time,ig_reels_avg_watch_time,plays,comments,reach,replies&access_token=${activeOrganization.InstagramIntegrations[0].pageToken}`,
        )
      }

      const commentsResponse = await axios.get(
        `https://graph.facebook.com/v20.0/${props.post.id}/comments?fields=id,text,username,timestamp&access_token=${activeOrganization.InstagramIntegrations[0].pageToken}`,
      )

      setPost({
        postDetails: props.post,
        insights: response.data.data,
        comments: commentsResponse.data.data,
      })
      setLoading(false)
    } catch (error) {
      console.error("Error fetching post insights:", error)
      setErr("Error fetching post data. Please try again.")
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchPost()
  }, [])

  const formatDate = dateString =>
    new Date(dateString).toLocaleString(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    })

  const scroollRef = useRef(null)

  const chartData = {
    series: [
      {
        name: "Value",
        data: post?.insights
          ? post.insights.map(metric => metric.values[0].value)
          : [],
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 290,
        toolbar: { show: false },
        colors: ["#2990DF"],
      },
      plotOptions: {
        bar: { horizontal: false, columnWidth: "55%" },
      },
      dataLabels: { enabled: false },
      xaxis: {
        categories: post?.insights
          ? post.insights.map(metric => metric.title || metric.name)
          : [],
      },
    },
  }

  return (
    <React.Fragment>
      <div className="d-lg-flex" style={{ width: "100%", overflowX: "hidden" }}>
        <SnackbarComponent
          err={err}
          success={success}
          setErr={setErr}
          setSuccess={setSuccess}
        />

        {/* Left Sidebar */}
        {post && (
          <Card className="chat-leftsidebar br">
            <CardBody style={{ maxHeight: "fit-content", overflow: "hidden" }}>
              <div className="text-center bg-light rounded px-4 py-3">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="text-start">
                    <span
                      className="mdi mdi-arrow-left"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        props.setSelectedPost(null)
                        props.setPostClicked(false)
                      }}
                    ></span>
                  </div>
                </div>
                <div className="chat-user-status">
                  <img
                    style={{ objectFit: "cover" }}
                    src={post?.postDetails.media_url || UserJPG}
                    className="avatar-md rounded-circle"
                    alt=""
                  />
                </div>
                <h5 className="font-size-14 mb-1 mt-3">
                  {post.postDetails.id}
                </h5>
                <p className="text-muted mb-0">
                  {formatDate(post.postDetails.timestamp)}
                </p>
              </div>
            </CardBody>

            {/* Sidebar Tabs */}
            <div className="chat-leftsidebar-nav">
              <TabContent activeTab={activeTab}>
                <TabPane tabId="1">
                  <div className="chat-message-list" style={{ height: "100%" }}>
                    <ul
                      className="list-unstyled chat-list p-3"
                      style={{ height: "100%" }}
                    >
                      <div>
                        {/* Helper functions for styling */}
                        {["Details", "Comments"].map(tabName => {
                          const isActive = currentActiveTab === tabName

                          const backgroundColor = isActive
                            ? "#2990DF"
                            : mode === "dark"
                              ? "transparent" // dark bg (tailwind slate-800)
                              : "transparent"

                          const titleColor = isActive
                            ? "#fff"
                            : mode === "dark"
                              ? "#e2e8f0" // light gray for dark mode
                              : "#000" // black for light mode

                          const subtitleColor = isActive
                            ? "#f1f5f9"
                            : mode === "dark"
                              ? "#94a3b8" // gray for dark mode
                              : "#6b7280" // gray for light mode

                          return (
                            <li
                              key={tabName}
                              className={isActive ? "active" : ""}
                              style={{
                                backgroundColor,
                                borderRadius: "8px",
                                transition: "background-color 0.2s ease",
                              }}
                              onMouseEnter={e => {
                                if (!isActive)
                                  e.currentTarget.style.backgroundColor =
                                    mode === "dark" ? "#334155" : "#f1f5f9"
                              }}
                              onMouseLeave={e => {
                                if (!isActive)
                                  e.currentTarget.style.backgroundColor =
                                    mode === "dark" ? "#1e293b" : "transparent"
                              }}
                            >
                              <Link
                                to="#"
                                onClick={() => setCurrentActiveTab(tabName)}
                                style={{
                                  color: isActive ? "#fff" : "inherit",
                                  display: "block",
                                  padding: "10px 12px",
                                  textDecoration: "none",
                                }}
                              >
                                <div className="d-flex align-items-center mt-2">
                                  <div className="flex-grow-1 overflow-hidden">
                                    <h5
                                      className="text-truncate font-size-15 mb-0"
                                      style={{ color: titleColor }}
                                    >
                                      {tabName}
                                    </h5>
                                    <p
                                      className="text-muted mb-0 mt-1 text-truncate"
                                      style={{ color: subtitleColor }}
                                    >
                                      {tabName === "Details"
                                        ? "Select to display details of post"
                                        : "Select to display post comments"}
                                    </p>
                                  </div>
                                </div>
                              </Link>
                            </li>
                          )
                        })}
                      </div>
                    </ul>

                    {/* Chart */}
                    <ReactApexChart
                      options={chartData.options}
                      series={chartData.series}
                      type="bar"
                      height="290"
                      className="mt-4"
                    />
                  </div>
                </TabPane>
              </TabContent>
            </div>
          </Card>
        )}

        {/* Right Content */}
        <div
          className="user-chat mt-4 mt-sm-0 ms-lg-3"
          style={{
            flex: 1,
            borderTopLeftRadius: "20px",
            borderTopRightRadius: "20px",
            height: "800px",
            maxWidth: "100%",
            overflow: "hidden",
          }}
        >
          <Card className="br">
            <div className="p-3 px-lg-4 border-bottom">
              <Row className="align-items-center">
                <Col
                  xs={12}
                  className="d-flex align-items-center justify-content-between"
                >
                  <h4 className="mt-2 text-truncate flex-grow-1">
                    {currentActiveTab}
                  </h4>
                </Col>
              </Row>
            </div>

            <SimpleBar
              ref={scroollRef}
              className="chat-conversation p-4"
              style={{
                height: "705px",
                borderBottomLeftRadius: "20px",
                borderBottomRightRadius: "20px",
              }}
            >
              {isLoading ? (
                <Spinners
                  style={{
                    color: mode === "dark" ? "#ffffff" : "#2990DF",
                  }}
                  setLoading={setLoading}
                />
              ) : currentActiveTab === "Details" && post ? (
                <div
                  style={{
                    maxWidth: "100%",
                    height: "600px",
                  }}
                >
                  <img
                    src={post.postDetails.media_url || UserJPG}
                    alt="Post"
                    style={{
                      width: "100%",
                      maxHeight: "300px",
                      objectFit: "cover",
                      borderRadius: "8px",
                      marginTop: "20px",
                    }}
                    className="rounded mb-3"
                  />

                  <h5>Caption:</h5>
                  <p style={{ wordBreak: "break-word" }}>
                    {post.postDetails.caption || "No caption available"}
                  </p>

                  <p>
                    <b>Media Type:</b> {post.postDetails.media_type}
                  </p>
                  <p>
                    <b>Timestamp:</b> {formatDate(post.postDetails.timestamp)}
                  </p>
                  <p>
                    <b>Permalink:</b>{" "}
                    <a
                      href={post.postDetails.permalink}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: "#2990DF",
                      }}
                    >
                      View Post
                    </a>
                  </p>
                </div>
              ) : currentActiveTab === "Comments" &&
                post?.comments?.length > 0 ? (
                <div>
                  <h5>Comments:</h5>
                  <ul className="list-unstyled">
                    {post.comments.map((comment, index) => (
                      <li key={index} style={{ marginBottom: "1.5rem" }}>
                        <div className="d-flex align-items-start">
                          <img
                            src={UserJPG}
                            alt="User Avatar"
                            className="avatar-xs rounded-circle me-3"
                          />
                          <div>
                            <h6 className="mb-1">
                              {comment?.username || "Instagram User (Private)"}
                            </h6>
                            <p
                              className="mb-1"
                              style={{ wordBreak: "break-word" }}
                            >
                              {comment.text}
                            </p>
                            <small className="text-muted">
                              {formatDate(comment.timestamp)}
                            </small>
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              ) : (
                <p>No comments available</p>
              )}
            </SimpleBar>
          </Card>
        </div>
      </div>
    </React.Fragment>
  )
}

export default connect(null, { setBreadcrumbItems })(CustomerDetails)
